import React from "react";
import { string, number, oneOfType, object, bool } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";

import DefaultMobileLogo from "../../../../assets/images/palo-bangla.svg";
import KishoraloLogo from "../../../../assets/images/kishoralo.svg";
import BigganChintaLogo from "../../../../assets/images/biggan-chinta.svg";
import EnglishHeaderLogo from "../../../../assets/images/palo-english.svg";
import NagorikLogo from "../../../../assets/images/nagorik.svg";
import NagorikWhiteLogo from "../../../../assets/images/whiteNagorik.svg";
import { headerLevelLogo, getCurrentSite } from "../../utils/utils";
import TrustLogo from "../../../../assets/images/trust-logo.svg";
import naLogo from "../../../../assets/images/Na_logo.svg";
import Icon from "../../icons";

import "./mobileLogo.m.css";

const MobileLogo = ({ domainSlug, publisherAttributes, pageType, currentPath, editLogo = false }) => {
  const HeaderTag = `h${headerLevelLogo(pageType)}`;

  const renderLogo = () => {
    if (domainSlug === "kishoralo" || getCurrentSite(currentPath) === "kishoralo") {
      return <img src={`${assetify(KishoraloLogo)}`} styleName="kishoralo-logo" />;
    } else if (domainSlug === "bondhushava" || getCurrentSite(currentPath) === "bondhushava") {
      return <Icon iconStyle={{ width: "132px", height: "36px" }} type="bondhushava" className="bondhushava" />;
    } else if (domainSlug === "protichinta" || getCurrentSite(currentPath) === "protichinta") {
      return <Icon iconStyle={{ width: "113px", height: "36px" }} type="protichinta" className="protichinta" />;
    } else if (
      domainSlug === "biggan-chinta" ||
      getCurrentSite(currentPath) === "biggan-chinta" ||
      domainSlug === "bigganchinta" ||
      getCurrentSite(currentPath) === "bigganchinta"
    ) {
      return <img src={`${assetify(BigganChintaLogo)}`} styleName="biggan-chinta-logo" />;
    } else if (domainSlug === "trust" || getCurrentSite(currentPath) === "trust") {
      return <img src={`${assetify(TrustLogo)}`} styleName="trust-logo" />;
    } else if (domainSlug === "northamerica") {
      return <img src={`${assetify(naLogo)}`} alt="na-logo" styleName="na-logo" className="desktop-na-logo na-logo" />;
    } else if (domainSlug === "nagorik-sangbad" || getCurrentSite(currentPath) === "nagorik-sangbad") {
      return editLogo ? (
        <img src={`${assetify(NagorikWhiteLogo)}`} styleName="nagorik-logo" />
      ) : (
        <img src={`${assetify(NagorikLogo)}`} styleName="nagorik-logo" />
      );
    } else if (
      domainSlug === "northamerica" ||
      domainSlug === "na" ||
      getCurrentSite(currentPath) === "northamerica" ||
      getCurrentSite(currentPath) === "na"
    ) {
      return <img src={`${assetify(naLogo)}`} alt="na-logo" styleName="na-logo" className="desktop-na-logo na-logo" />;
    } else if (publisherAttributes.lang === "en" || getCurrentSite(currentPath) === "en") {
      return <img src={`${assetify(EnglishHeaderLogo)}`} alt="palo-logo" styleName="palo-english-logo" />;
    } else {
      return <img src={`${assetify(DefaultMobileLogo)}`} styleName="palo-logo" />;
    }
  };
  return <HeaderTag className="mobile-logo">{renderLogo()}</HeaderTag>;
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
});

MobileLogo.propTypes = {
  domainSlug: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  color: string,
  publisherAttributes: object,
  pageType: string,
  currentPath: string,
  editLogo: bool,
};

export default connect(mapStateToProps, null)(MobileLogo);
